// extracted by mini-css-extract-plugin
module.exports =  {"default":"_32bbee5fda--default--t0tX7","light":"_32bbee5fda--light--s9E4P","outline":"_32bbee5fda--outline--osTFY"};